import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { v4 } from 'uuid';
const DialogRelatorio = ({ departamentos, normas, onClose, ...props }) => {
    const validationSchema = yup.object({
        coreDepartamentoId: yup.number().required('O campo é obrigatório'),
        coreListaNormaId: yup.number().required('O campo é obrigatório'),
        titulo: yup.string().required('O campo é obrigatório'),
        subtitulo: yup.string().required('O campo é obrigatório')
    });
    const formik = useFormik({
        initialValues: {},
        validationSchema: validationSchema,
        validateOnMount: false,
        onSubmit: async (values) => {
            let a = {
                titulo: values.titulo,
                subtitulo: values.subtitulo,
                coreListaNormaId: values.coreListaNormaId,
                coreDepartamentoId: values.coreDepartamentoId
            };
            onClose(a);
        }
    });
    useEffect(() => {
        formik.resetForm();
    }, [departamentos, normas]);
    return (<form>
      <Dialog {...props} maxWidth={'lg'} fullWidth>
        <DialogTitle>Adicionar modelo de relatório</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={2} md={4} xs={4}>
              <TextField label='Departamento' name='coreDepartamentoId' fullWidth defaultValue={formik.values?.coreDepartamentoId} onChange={_ => {
            formik.setFieldValue('coreListaNormaId', formik.initialValues.coreListaNormaId, true);
            formik.setFieldTouched('coreListaNormaId', false, true);
            formik.handleChange(_);
        }} onBlur={formik.handleBlur} error={formik.touched.coreDepartamentoId && Boolean(formik.errors.coreDepartamentoId)} helperText={formik.touched.coreDepartamentoId && formik.errors.coreDepartamentoId} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {departamentos.map(x => (<MenuItem value={x.id} key={x.id}>
                    {x.designacao}
                  </MenuItem>))}
              </TextField>
            </Grid>
            <Grid lg={10} md={8} xs={8}>
              <TextField label='IG' name='titulo' defaultValue={formik.values?.titulo} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.titulo && Boolean(formik.errors.titulo)} helperText={formik.touched.titulo && formik.errors.titulo}/>
            </Grid>
            {formik.values.coreDepartamentoId && (<Grid lg={12} md={12} xs={12}>
                <TextField key={`${formik.values.coreDepartamentoId}-${v4()}`} label='Procedimento' name='coreListaNormaId' fullWidth defaultValue={formik.values?.coreListaNormaId} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.coreListaNormaId && Boolean(formik.errors.coreListaNormaId)} helperText={formik.touched.coreListaNormaId && formik.errors.coreListaNormaId} select>
                  <MenuItem value={undefined} disabled></MenuItem>
                  {normas
                .filter(r => r.coreDepartamentoId == formik.values.coreDepartamentoId)
                .map(x => (<MenuItem value={x.id} key={x.id}>
                        {x.designacao}
                      </MenuItem>))}
                </TextField>
              </Grid>)}
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Designação' name='subtitulo' defaultValue={formik.values?.subtitulo} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.subtitulo && Boolean(formik.errors.subtitulo)} helperText={formik.touched.subtitulo && formik.errors.subtitulo}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </form>);
};
export default DialogRelatorio;
